export default "__VITE_ASSET__Bg936KON__"